export default __webpack_public_path__ + "static/media/how-it-works-1-mob.57a68ae1.png";